// extracted by mini-css-extract-plugin
export default {"root":"Ellipsis_root__MSO2s"};